import { render, staticRenderFns } from "./POStestlist.vue?vue&type=template&id=3281f00a"
import script from "./POStestlist.vue?vue&type=script&lang=js"
export * from "./POStestlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports